import BlogLayout from '../../layout/BlogLayout'
import Image1 from '../../assets/blog/article-1/1.webp'
import Image2 from '../../assets/blog/article-1/2.webp'
import Image3 from '../../assets/blog/article-1/3.webp'

const Article1 = () => {
  return (
    <BlogLayout
      category='Taller'
      title='Soltar, crear, resignificar: Lo que nos dejó “Conectá con tu yo artista”'
    >
      <p>
        El jueves 24 de abril nos encontramos en Vida Cowork – Sede Wast para vivir un
        momento único: una invitación a bajar el ritmo, mirar hacia adentro y darle espacio
        a nuestra creatividad más genuina.
      </p>
      <p>
        En el marco del Día de la Tolerancia y el Respeto a los Pueblos, nos propusimos
        generar un encuentro donde cada persona pudiera expresarse, conectar con su esencia
        y honrar su historia.
      </p>
      <p>
        La tarde comenzó con una práctica de apertura para habitar el presente, entregarnos
        y preparar el terreno interno para todo lo que estaba por emerger.
      </p>
      <p>
        Después, a través de un conversatorio llamado{' '}
        <span className="quote">“La palabra como canal, puente y expresión del alma”</span>, reflexionamos
        sobre el poder de la palabra: cómo crea, conecta y resignifica nuestras
        experiencias.
      </p>
      <img src={Image1} alt="Blog" className="img--small" />
      <p>
        Cada participante trajo consigo un objeto pequeño y cargado de significado, como
        símbolo de algo que sentían listo para soltar. A partir de este gesto, creamos una
        dinámica colectiva de resignificación y expresión artística que dejó huellas
        profundas.
      </p>
      <p>
        Entre palabras, silencios, colores e intenciones, cada quien pudo dejar fluir su yo
        artista, reconectar con sus raíces y darse el permiso de crear desde un lugar
        auténtico y libre.
      </p>
      <p>
        Fue un encuentro cargado de sensibilidad, respeto y transformación. Una prueba más
        de que cuando nos damos el espacio para escuchar adentro, algo muy verdadero puede
        nacer.
      </p>
      <img src={Image2} alt="Blog" className="img--medium" />
      <img src={Image3} alt="Blog" className="img--small" />
      <p>
        Gracias a cada persona que se sumó, y a Vida, por seguir creando espacios donde el
        trabajo, la creatividad y el bienestar se encuentran.
      </p>
    </BlogLayout>
  )
}

export default Article1